import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from "react";
import { useSaleorClient } from "./helpers";

// keep track of called mutation
var useMutationTracking = function () {
  var _mutationId = 0;

  var generateNewMutationId = function generateNewMutationId() {
    _mutationId += 1;
    return _mutationId;
  };

  var isMostRecentMutation = function isMostRecentMutation(mutationId) {
    return _mutationId === mutationId;
  };

  return function () {
    return {
      generateNewMutationId: generateNewMutationId,
      isMostRecentMutation: isMostRecentMutation
    };
  };
}();

var initialState = {
  called: false,
  data: null,
  error: null,
  loading: false
};

var useMutation = function useMutation(mutation) {
  var baseVariables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var baseOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var saleor = useSaleorClient();

  var _useMutationTracking = useMutationTracking(),
      generateNewMutationId = _useMutationTracking.generateNewMutationId,
      isMostRecentMutation = _useMutationTracking.isMostRecentMutation;

  var _React$useState = React.useState(initialState),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      result = _React$useState2[0],
      setResult = _React$useState2[1];

  var handleMutationStart = function handleMutationStart() {
    if (!result.loading) {
      setResult({
        called: true,
        data: null,
        error: null,
        loading: true
      });
    }
  };

  var handleMutationError = function handleMutationError(error, mutationId) {
    if (isMostRecentMutation(mutationId)) {
      setResult(function (prevState) {
        return _objectSpread({}, prevState, {
          error: error,
          loading: false
        });
      });
    }
  };

  var handleMutationComplete = function handleMutationComplete(data, mutationId) {
    if (isMostRecentMutation(mutationId)) {
      setResult(function (prevState) {
        return _objectSpread({}, prevState, {
          data: data,
          loading: false
        });
      });
    }
  };

  var runMutation = React.useCallback(function (variables, options) {
    return new Promise(function (resolve) {
      handleMutationStart();
      var mutationId = generateNewMutationId();

      var apolloVariables = _objectSpread({}, baseVariables, variables);

      var apolloOptions = _objectSpread({}, baseOptions, options);

      saleor.legacyAPIProxy[mutation](apolloVariables, apolloOptions).then(function (data) {
        handleMutationComplete(data.data, mutationId);
        resolve(data);
      }).catch(function (err) {
        handleMutationError(err, mutationId);
        resolve(null);
      });
    });
  }, [mutation, baseOptions]);
  return [runMutation, result];
};

export var mutationFactory = function mutationFactory(mutation) {
  return function (variables, options) {
    return useMutation(mutation, variables, options);
  };
};